var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isOpen)?_c('div',{staticClass:"window-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.close.apply(null, arguments)}}},[_c('div',{staticClass:"window-container"},[_c(_vm.filterSortComponent,{tag:"component"})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }